<app-home-behaviorlive *ngIf="settings.brand.brandName == 'BehaviorLive'"></app-home-behaviorlive>
<app-home-okwhen *ngIf="settings.brand.brandName == 'OkWhen'"></app-home-okwhen>
